import { mapActions } from 'vuex';
import { decode } from 'utils/general';
import bus from 'lib/bus';

export default {
  props: [
    'ctaType',
    'handle',
    'product',
    'variants',
    'parentTitle',
    'listType',
    'cardIndex',
    'bundleItemSelected',
    'replaceBBProduct',
    'hasAvailableProducts',
    'stepProducts',
    'step',
    'parentId',
  ],
  data() {
    return {
      disabled: false,
      activeStep: this.step,
    };
  },
  computed: {
    addText() {
      return this.$t('products.product.add');
    },
    addedText() {
      return this.$t('products.product.added');
    },
    oosText() {
      return this.$t('products.card.out_of_stock');
    },
    selectText() {
      return this.$t('cart.gwp.select');
    },
    selectedText() {
      return this.$t('cart.gwp.selected');
    },
    selectOptionText() {
      return this.$t('bundle_builder.select_option');
    },
  },
  methods: {
    ...mapActions('global', ['openModal']),
    ...mapActions('quickView', [
      'setProduct',
      'updateModalTitle',
      'updateCtaText',
      'updateItemToUpdate',
      'updateAction',
      'setVariant',
    ]),
    ...mapActions('cart', [
      'openCart',
      'closeCart',
      'addBundleItemsToCart',
      'updateCartLine',
    ]),
    getAddToCartType() {
      let addToCartType = 'Home';

      if (window.location.pathname.indexOf('/collections') > -1) {
        addToCartType = 'Product List Page';
        if (window.location.pathname.indexOf('/products') > -1) {
          addToCartType = 'Product Detail Page';
        }
      } else if (window.location.pathname.indexOf('/cart') > -1) {
        addToCartType = 'Cart';
      } else if (window.location.pathname.indexOf('/products') > -1) {
        addToCartType = 'Product Detail Page';
      } else if (window.location.pathname.indexOf('/pages') > -1) {
        addToCartType = 'Landing Page';
      } else if (window.location.pathname.indexOf('/account') > -1) {
        addToCartType = 'Account Page';
      }

      return addToCartType;
    },
    openQuickShopModal() {
      this.product.isBbProduct = true;
      if (this.replaceBBProduct) {
        this.product.replaceBBStep = this.step;
      }

      let product = this.product;
      if (typeof this.product === 'string') {
        product = JSON.parse(decode(this.product));
      }

      const hasRestrictedSizes = this.variants.find((variant) =>
        variant.bundleBuilderProductIds?.includes(this.parentId),
      );
      let variants = this.variants;

      if (hasRestrictedSizes) {
        variants = this.variants.map((variant) => {
          return {
            ...variant,
            is_disabled:
              variant?.bundleBuilderProductIds?.includes(this.parentId) ===
              false,
          };
        });
      }

      product = {
        ...product,
        parentTitle: this.parentTitle,
        listType: this.listType,
        index: this.cardIndex + 1,
        componentName: 'Bundle Builder Quickview',
        siteSection: window.__GLOBAL__.siteSection,
        selectedShades: this.product.selectedShades || false,
        origin: 'select shade',
        variants,
      };
      this.setProduct(product);
      const firstVariant = variants.find((v) => v.is_disabled === false);
      if (firstVariant) this.setVariant(firstVariant.id);
      this.openModal('quick-view');
      this.trackSelectItem(this.product, true);
    },
    trackSelectItem() {
      this.$emit('track-item', true);
    },
    addRemoveProductToBundle(item) {
      if (this.replaceBBProduct) {
        if (this.bundleItemSelected || this.activeStep !== this.step) {
          bus.$emit('bb-item-added', item);
        } else {
          // delete prev selected item and add new
          bus.$emit('bb-delete-all', this.step);
          bus.$emit('bb-item-added', item);
        }
        return;
      }
      if (!this.hasAvailableProducts && !this.bundleItemSelected) {
        // show error when all available products have been selected
        bus.$emit('show-error-message');
        return;
      }
      bus.$emit('bb-item-added', item);
    },
  },
  template: `
    <div
      class="product-card__cta-primary"
      :class="{'disabled': disabled }"
    >
      <button
        class="btn btn--grayed w1"
        v-if="ctaType === 'quick-shop' && !bundleItemSelected"
        @click.prevent="openQuickShopModal"
        data-module-name="bb product card cta actions"
        :aria-label="selectText">
        {{ selectOptionText }}
        <slot></slot>
      </button>
      <button
        class="btn btn--grayed w1" v-else-if="ctaType === 'add' && !bundleItemSelected"
        @click="addRemoveProductToBundle(product)"
        data-module-name="bb product card cta actions"
        :aria-label="selectedText">
         {{ addText }}
      </button>
      <button
        class="btn btn--primary w1" v-else-if="bundleItemSelected"
        @click="addRemoveProductToBundle(product)"
        data-module-name="bb product card cta actions"
        :aria-label="addedText">
         {{ addedText }}
      </button>
    </div>
  `,
};
